import { useLocation } from "react-router-dom-v5-compat";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import {
  CoreFlightSteps,
  FlightsNavigationFlow,
} from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { usePriceDisplay } from "@tenant/ui";
import styles from "./styles.module.scss";

// This is a temp function, the ultimate goal is to have a single
// review page, not review and review fare. This is a hack to get hardcoded
// current step from previous page
const getCurrentStep = (pathname: string) => {
  return pathname.endsWith("fare")
    ? CoreFlightSteps.REVIEW_FARE
    : CoreFlightSteps.REVIEW;
};

export const ReviewBreakdown = ({ passengerPricing }) => {
  const [block] = useModuleBEM(styles, CoreFlightsComponent.ReviewBreakdown);
  const { t } = useI18nContext();

  const { pathname } = useLocation();
  const currentStep = getCurrentStep(pathname);
  const goToNextStep = FlightsNavigationFlow.useGoToNextStep(currentStep);

  const { combinedText } = usePriceDisplay({
    prices: passengerPricing.pricing.total,
  });

  return (
    <button className={block} onClick={() => goToNextStep()}>
      {t("pricePerTraveller", {
        price: combinedText,
        interpolation: { escapeValue: false },
      })}
    </button>
  );
};
